import React from 'react'
import { ActionListItem, Avatar, Box, Highlight, Tooltip } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { ListItemAnimation } from 'components/Animations/ListItemAnimation'
import { PaymentMethodStatusColourMapping } from 'pages/ManageBeneficiaries/constants'
import { BeneficiaryDetails } from 'types/beneficiaries'
import { getBeneficiaryName } from 'utils/beneficiaries'
import { BeneficiaryEntityTypeHighlight } from './BeneficiaryEntityTypeHighlight'

interface BeneficiaryListProps {
  beneficiaries: BeneficiaryDetails[]
  handleBeneficiarySelect: (beneficiary: BeneficiaryDetails) => void
}
export const BeneficiaryList = ({
  beneficiaries,
  handleBeneficiarySelect,
}: BeneficiaryListProps) => {
  return (
    <>
      {beneficiaries?.map((beneficiary, index) => {
        const isLastTwo = beneficiaries?.length - index <= 2
        const isNextToAnimate =
          beneficiaries?.length - index > 2 && beneficiaries?.length - index <= 10

        return (
          <ListItemAnimation
            key={beneficiary?.reference}
            reference={beneficiary?.reference}
            index={index}
            listLength={beneficiaries?.length}
            hasLoadedMore={false}
            isLastTwo={isLastTwo}
            isNextToAnimate={isNextToAnimate}
          >
            <ActionListItem
              key={beneficiary?.reference}
              id={beneficiary?.reference}
              title={getBeneficiaryName(beneficiary)}
              testId={`contacts-step-list-item-${index}`}
              HeaderHighlightRight={<BeneficiaryEntityTypeHighlight beneficiary={beneficiary} />}
              HeaderHighlightLeft={
                <p className="text-body-regular text-foreground-prominent">{beneficiary?.alias}</p>
              }
              Avatar={<Avatar type="entity" name={getBeneficiaryName(beneficiary) ?? ''} />}
              BodyPre={
                <Tooltip type="simple" bodyContent={beneficiary?.fiat?.accountNumber}>
                  <Box
                    onMouseEnter={e => e.stopPropagation()}
                    onMouseLeave={e => e.stopPropagation()}
                  >
                    {`${ellipseMiddleText(beneficiary?.fiat?.accountNumber, 6, 6)}`}
                  </Box>
                </Tooltip>
              }
              BodyPost={beneficiary?.fiat?.code}
              onItemClick={() => handleBeneficiarySelect(beneficiary)}
              {...(beneficiary?.paymentMethod && {
                ActionHighlight: (
                  <Highlight
                    variant="emphasis"
                    type={PaymentMethodStatusColourMapping[beneficiary?.paymentMethod]}
                  >
                    {beneficiary?.paymentMethod}
                  </Highlight>
                ),
              })}
            />
          </ListItemAnimation>
        )
      })}
    </>
  )
}
